var map = {
	"./1/avatar.png": "hZOf",
	"./2/avatar.png": "NA/K",
	"./3/avatar.png": "9Air",
	"./4/avatar.png": "3lE/",
	"./5/avatar.png": "G9ya",
	"./6/avatar.png": "oqJ0",
	"./7/avatar.png": "aeym",
	"./8/avatar.png": "UaLT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m3Ew";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/avatar\.png$
// module id = m3Ew
// module chunks = 1